// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const StatusPositiveIcon = createSvgIcon(
  <svg fill="none">
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} />
    <path
      stroke="currentColor"
      strokeWidth={2}
      d="M16.5 11.88h-9M12.13 16.5v-9"
    />
  </svg>,
  "StatusPositive",
);
export default StatusPositiveIcon;
